<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
let location = ref(locale.value);

let imageUrl = ref(new URL(`/public/assets/${locale.value}/Samsung.png`, import.meta.url).href)
watch(locale, () => {
    location = locale.value;
    imageUrl.value = new URL(`/public/assets/${locale.value}/Samsung.png`, import.meta.url).href
});

watch(locale, () => {
    location = locale.value;
});
</script>
<template>
    <div class="inner-wrapper">
        <div class="box">
            <div class="row h-100">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="image-wrapper" data-aos="zoom-in">
                        <img :src=imageUrl />
                    </div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 no-padding-right">
                    <div class="info-wrapper">
                        <div class="functionalitites-space-wrapper">
                            <div class="info-inner-wrapper">
                                <div class="info-content">
                                    <div class="functionalities-block-title">
                                        <div class="title-wrapper">
                                            <span class="primary-text">{{ $t('field.car') }}</span>
                                            {{ $t('field.appointments') }}
                                        </div>
                                    </div>
                                    <div class="functionalities-block-subtitle">
                                        {{ $t('functionalities.appointments_description') }}
                                    </div>
                                    <div class="funcionalities-cases">
                                        <div class="case">
                                            <div class="title">
                                                {{ $t('functionalities.appointments_case_1_title') }}
                                            </div>
                                        </div>
                                        <div class="case">
                                            <div class="subtitle">
                                                {{ $t('functionalities.appointments_case_1_subtitle') }}
                                            </div>
                                        </div>
                                        <div class="case">
                                            <div class="subtitle">
                                                {{ $t('functionalities.appointments_case_2_subtitle') }}
                                            </div>
                                        </div>
                                        <div class="case">
                                            <div class="subtitle">
                                                {{ $t('functionalities.appointments_case_3_subtitle') }}
                                            </div>
                                        </div>
                                        <div class="case">
                                            <div class="subtitle">
                                                {{ $t('functionalities.appointments_case_4_subtitle') }}
                                            </div>
                                        </div>
                                        <div class="case">
                                            <div class="subtitle">
                                                {{ $t('functionalities.appointments_case_5_subtitle') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="functionalities-block-subtitle functionalities_footer">
                                        {{ $t('functionalities.appointment_sub_footer_1') }}
                                    </div>
                                    <div class="functionalities-block-subtitle functionalities_footer_no_bold">
                                        {{ $t('functionalities.appointment_sub_footer_2') }}
                                    </div>
                                </div>
                                <div class="functionalitites-plus">
                                    <router-link :to="`/${location}/appointments`">
                                        <font-awesome-icon icon="fa-solid fa-plus" />
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .inner-wrapper {
        padding: 25px 0;
    }
    .box {
        background: #EDEFF2 0% 0% no-repeat padding-box;
        border-radius: 20px;
        height: 406px;
        padding: 10px 30px 20px;
        .row {
            margin: 0;
            padding: 0;
        }
        .no-padding-right {
            padding-right: 0px;
        }
        .image-wrapper {
            position: relative;
            height: 100%;
            img {
                position: absolute;
                border: 0px;
                right: 10px;
                bottom: -45px;
            }
        }
        .functionalities-block-title {
            font-size: 30px;
            letter-spacing: -1.5px;
            text-transform: lowercase;
            font-family: 'CircularStd-Bold';
            padding-bottom: 18px;
            padding-top: 10px;
        }
        .functionalities-block-subtitle {
            font-size: 16px;
            letter-spacing: -0.4px;
            font-weight: bold;
            padding-bottom: 18px;
            &.functionalities_footer {
                padding-bottom: 0px;
                font-size: 18px;
                &:nth-child(even){
                    padding-top: 20px;
                }
            }
            &.functionalities_footer_no_bold {
                font-family: 'CircularStd-Book';
                font-weight: normal;
                padding-bottom: 0;
            }
        }
        .funcionalities-cases {
            font-size: 16px;
            letter-spacing: -0.4px;
            .title {
                font-size: 16px;
                font-family: 'CircularStd-Bold';
            }
        }
        .info-wrapper {
            height: 100%;
            display: flex;
            .info-inner-wrapper {
                align-self: flex-end;
                height: 100%;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
            .functionalitites-space-wrapper {
                width: 100%;
            }
            .info-content {
                padding-top: 0px;
            }
        }
        .functionalitites-plus {
            font-size: 25px;
            text-align: right;
            padding-top: 5px;
            a {
                color: #0047ba;
                display: inline-block;
                transition: transform .7s ease-in-out;
                &:hover {
                    transform: rotate(90deg);
                }
            }
        }
    }
    @media (max-width: 1000px) {
        .container-functionality-wrapper {
            padding: 60px 50px;
            .functionalitites-blocks  {
                padding: 0;
            }
        }
        .box {
            height: auto;
            .image-wrapper {
                position: relative;
                right: 10px;
                height: 250px;
                img {
                    position: absolute;
                    right: 3%;
                    bottom: -100px;
                    height: 450px;
                }
            }
        }
    }  
    @media (max-width: 600px) {
        .box {
            height: auto;
            .image-wrapper {
                position: relative;
                right: 40px;
                height: 250px;
                img {
                    position: absolute;
                    right: 0%;
                    bottom: -35px;
                    height: 450px;
                }
            }
        }
    }
    @media (max-width: 400px) {
        .box {
            height: auto;
            .image-wrapper {
                position: relative;
                right: 40px;
                height: 250px;
                img {
                    position: absolute;
                    right: 0%;
                    bottom: -35px;
                    height: 450px;
                }
            }
            .no-padding-right {
                padding-left: 0;
            }
        }
    }         
</style>